import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import UnpaidAgentsPage from "../modules/UnpaidAgents/UnpaidAgentsPage";

export function UnpaidAgents() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "unpaidAgents-page-title",
    defaultMessage: "Unpaid agents"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <UnpaidAgentsPage/>;
}
